export default {
  cities: {
    analytics: {
      event: 'Cities Clicked',
      data: (link) => ({
        name: link.name,
      }),
    },
    links: [
      {
        label: 'London',
        name: 'London',
        url: '/office-space-london',
      },
    ],
    title: 'Cities',
  },
  londonAreas: {
    analytics: {
      event: 'London Area Clicked',
      data: (link) => ({
        name: link.name,
      }),
    },
    links: [
      {
        label: 'Central London',
        name: 'central-london',
        url: '/office-space-london/central-london',
      },
      {
        label: 'East London',
        name: 'east-london',
        url: '/office-space-london/east-london',
      },
      {
        label: 'North London',
        name: 'north-london',
        url: '/office-space-london/north-london',
      },
      {
        label: 'South London',
        name: 'south-london',
        url: '/office-space-london/south-london',
      },
      {
        label: 'West London',
        name: 'west-london',
        url: '/office-space-london/west-london',
      },
    ],
    title: 'London Areas',
  },
  popularLondonAreas: {
    analytics: {
      event: 'Popular London Areas Clicked',
      data: (link) => ({
        name: link.name,
      }),
    },
    links: [
      {
        label: 'Canary Wharf',
        name: 'canary-wharf',
        url: '/office-space-london/canary-wharf',
      },
      {
        label: 'Clerkenwell',
        name: 'clerkenwell',
        url: '/office-space-london/clerkenwell',
      },
      {
        label: 'Euston',
        name: 'euston',
        url: '/office-space-london/euston-station',
      },
      {
        label: 'Farringdon',
        name: 'farringdon',
        url: '/office-space-london/farringdon-station',
      },
      {
        label: 'Holborn',
        name: 'holborn',
        url: '/office-space-london/holborn-station',
      },
      {
        label: "King's Cross",
        name: "king's-cross-st.-pancras",
        url: "/office-space-london/king's-cross-st.-pancras-station",
      },
      {
        label: 'Liverpool St',
        name: 'liverpool-street',
        url: '/office-space-london/liverpool-street-station',
      },
      {
        label: 'London Bridge',
        name: 'london-bridge',
        url: '/office-space-london/london-bridge-station',
      },
      {
        label: 'Marylebone',
        name: 'marylebone',
        url: '/office-space-london/marylebone-station',
      },
      {
        label: 'Mayfair',
        name: 'mayfair',
        url: '/office-space-london/mayfair',
      },
      {
        label: 'Moorgate',
        name: 'moorgate',
        url: '/office-space-london/moorgate-station',
      },
      {
        label: 'Old Street',
        name: 'old-street',
        url: '/office-space-london/old-street-station',
      },
      {
        label: 'Paddington',
        name: 'paddington',
        url: '/office-space-london/paddington-station',
      },
      {
        label: 'Shoreditch',
        name: 'shoreditch',
        url: '/office-space-london/shoreditch',
      },
      {
        label: 'Soho',
        name: 'soho',
        url: '/office-space-london/soho',
      },
    ],
    title: 'Popular London Areas',
  },
};
